var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlack3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4471_8989)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32085 -0.0234375C8.64897 -0.0234375 8.9771 -0.0234375 9.30522 -0.0234375C10.4229 0.274036 11.1026 0.992784 11.3443 2.13281C11.3677 3.10144 11.3756 4.07018 11.3677 5.03906C10.3031 5.06002 9.24063 5.03658 8.18022 4.96875C6.85033 4.54402 6.21752 3.62995 6.28179 2.22656C6.47979 1.0365 7.15947 0.286503 8.32085 -0.0234375Z",
    fill: "#00C5F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.989,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6487 -0.0234375C14.9768 -0.0234375 15.3049 -0.0234375 15.6331 -0.0234375C16.6758 0.245835 17.3399 0.902086 17.6252 1.94531C17.7018 4.31901 17.7175 6.69398 17.6721 9.07031C17.4236 10.4915 16.5799 11.2571 15.1409 11.3672C13.7291 11.2834 12.8853 10.5491 12.6096 9.16406C12.5638 6.74044 12.5794 4.31857 12.6565 1.89844C12.9637 0.880163 13.6278 0.239537 14.6487 -0.0234375Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.988,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.0234375 9.30656C-0.0234375 8.97843 -0.0234375 8.65031 -0.0234375 8.32218C0.245835 7.27945 0.902086 6.61537 1.94531 6.32999C4.31901 6.2534 6.69398 6.23774 9.07031 6.28312C10.491 6.52968 11.2566 7.37343 11.3672 8.81437C11.284 10.2256 10.5497 11.0693 9.16406 11.3456C6.74072 11.3912 4.31882 11.3756 1.89844 11.2987C0.880163 10.9915 0.239537 10.3274 -0.0234375 9.30656Z",
    fill: "#00C5F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9756 8.32031C23.9756 8.64844 23.9756 8.97656 23.9756 9.30469C23.6724 10.4436 22.938 11.1233 21.7725 11.3438C20.8195 11.3672 19.8663 11.375 18.9131 11.3672C18.9053 10.3671 18.9131 9.36708 18.9365 8.36719C19.2496 7.04653 20.0856 6.34341 21.4443 6.25781C22.7808 6.34711 23.6246 7.03463 23.9756 8.32031Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.989,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.0234375 15.6318C-0.0234375 15.3037 -0.0234375 14.9756 -0.0234375 14.6475C0.274036 13.5298 0.992784 12.8501 2.13281 12.6084C3.10144 12.585 4.07018 12.5771 5.03906 12.585C5.04689 13.5851 5.03906 14.5851 5.01563 15.585C4.5856 17.1482 3.56216 17.8279 1.94531 17.624C0.902086 17.3387 0.245835 16.6746 -0.0234375 15.6318Z",
    fill: "#FF175A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30475 23.9766C8.97662 23.9766 8.6485 23.9766 8.32037 23.9766C7.27764 23.7073 6.61356 23.0511 6.32818 22.0078C6.25136 19.6343 6.23575 17.2593 6.28131 14.8828C6.5274 13.4623 7.37115 12.6967 8.81256 12.5859C10.2241 12.6694 11.0678 13.4038 11.3438 14.7891C11.3897 17.2127 11.374 19.6346 11.2969 22.0547C10.9897 23.073 10.3256 23.7136 9.30475 23.9766Z",
    fill: "#FF175A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.987,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9766 14.6467C23.9766 14.9749 23.9766 15.303 23.9766 15.6311C23.7073 16.6738 23.0511 17.3379 22.0078 17.6233C19.6341 17.6999 17.2591 17.7155 14.8828 17.6702C13.4616 17.4217 12.696 16.5779 12.5859 15.1389C12.6694 13.7274 13.4038 12.8837 14.7891 12.6077C17.2127 12.5618 19.6346 12.5775 22.0547 12.6545C23.073 12.9618 23.7136 13.6258 23.9766 14.6467Z",
    fill: "#FFB20E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6318 23.9762C15.3037 23.9762 14.9756 23.9762 14.6475 23.9762C13.5298 23.6787 12.8501 22.96 12.6084 21.8199C12.585 20.8513 12.5771 19.8825 12.585 18.9137C13.6495 18.8927 14.7121 18.9162 15.7725 18.984C16.9677 19.3648 17.6083 20.1851 17.6943 21.4449C17.605 22.7814 16.9175 23.6252 15.6318 23.9762Z",
    fill: "#FFB20E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4471_8989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack3);
export default __webpack_public_path__ + "static/media/slack (3).bd7a7f1a82a2370f744d1ac1a1a4ec8a.svg";
export { ForwardRef as ReactComponent };